import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchClient } from '../utilities/fetchClient';
import ActionTypes from '../actions/actionTypes';
import {  getInvoicesSuccessAction, getInvoicesFailureAction } from '../actions/accountActions';
import Env from '../Env';

function* getInvoices(action) {
  try {
    const header = {
      'Ocp-Apim-Subscription-Key': Env.getApimKey(),
    };

    const { grandParentAccountNumber, accountNumber, ...queryParams } = action.payload;

    const response = yield call(fetchClient, {
      url: `reports-api/v1/reports/invoicing/${grandParentAccountNumber}/${accountNumber}/invoices?`,
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
      queryParams: queryParams,
    });
    yield put(getInvoicesSuccessAction(response));
  } catch (e) {
    yield put(getInvoicesFailureAction());
  }
}

export default function* invoicesSaga() {
  yield takeLatest(ActionTypes.ACCOUNTS.INVOICES.REQUEST, getInvoices);
}
